module.exports = __webpack_public_path__ + "img/3.bf985db5.png";